import { useState } from "react";
import { Box, Typography, Collapse, IconButton } from "@mui/material";
import { ExpandMore as ExpandIcon } from "@mui/icons-material";
import { type JobResponse } from "@taxassist/api-client";
import { JobStatusTimeline } from "./JobStatusTimeline";
import { getStatusDisplay } from "../../utils/statusMapping";

interface JobTimelineSectionProps {
  job: JobResponse;
  context?: "client" | "ops";
}

export function JobTimelineSection({
  job,
  context = "client",
}: JobTimelineSectionProps) {
  const getInitialOpenState = () => {
    if (context !== "client") return true;

    const simplifiedStatus = getStatusDisplay(job.status);

    if (
      simplifiedStatus === "Unsubmitted" ||
      simplifiedStatus === "New Files"
    ) {
      return false;
    }

    if (simplifiedStatus === "Queued" || simplifiedStatus === "In Progress") {
      return true;
    }

    if (simplifiedStatus === "Done") {
      return false;
    }

    return true;
  };

  const [open, setOpen] = useState(getInitialOpenState());
  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "#FFFFFF",
        borderRadius: 2,
        border: 1,
        borderColor: "#E7E7E7",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          aria-label="collapse"
          onClick={handleToggle}
          size="small"
          sx={{ transform: open ? "rotate(0)" : "rotate(-90deg)" }}
        >
          <ExpandIcon />
        </IconButton>

        <Typography variant="h6" sx={{ color: "text.primary" }}>
          2. Track Progress
        </Typography>
      </Box>
      <Collapse in={open}>
        <JobStatusTimeline
          statusHistory={job.statusUpdateHistory}
          currentStatus={job.status}
          orientation="vertical"
        />
      </Collapse>
    </Box>
  );
}
